export default __webpack_public_path__ + "static/media/Icon-Right_Arrow_Cold.2cf29401.svg";